import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import StoryListPage from './story-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Stories">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Stories</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <StoryListPage />
    </Panel>
  );
};

export default Page;
